<template>

    <div class="route-login">

        <div class="content">
            <div class="content-holder">

                <div class="logos-holder">
                    <div class="logo">
                        <i class="img logo-aveco-color-180"></i>
                    </div>
                </div>

                <h1>Inloggen</h1>

                <form @submit.prevent="login">
                    <cms-input type="text" name="username" placeholder="Gebruikersnaam" v-model="username"></cms-input>
                    <cms-input type="password" placeholder="Wachtwoord" v-model="password"></cms-input>

                    <cms-button :loading="loading" @click="login">Inloggen</cms-button>
                    <input type="submit" style="display: none" />
                </form>

                <div class="nav-link">
                    <router-link :to="{ name: 'forgot' }">Wachtwoord vergeten</router-link>
                </div>

            </div>
        </div>

        <toast-container></toast-container>

    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import EmailAccountType from 'app/auth/EmailAccountType'

    import getUrlParams from '@wittignl/js-core/utils/getUrlParams'
    import getGraphQLError from 'app/utils/getGraphQLError';
    import ApiError from 'app/enums/ApiError';

    @Component({

        name: 'login'
    })
    export default class Login extends Vue
    {
        data(){

            return {
                loading: false,

                username: null,
                password: null
            }
        }

        mounted() {

            this.logger = this.$di.logger.child('Login');
            this.logger.info('Mounted');
        }

        async login(){

            if(!this.username || !this.password){

                this.$toast.error('Voer uw gebruikersnaam en wachtwoord in');
                return;
            }

            this.loading = true;
            this.logger.info(`Logging in ${this.username}`);

            const urlParams = getUrlParams(window.location.search);
            const app = urlParams.app || 'mijn-aveco';
            const path = urlParams.path || null;

            try {

                await this.$auth.login(EmailAccountType.NAME, { username: this.username, password: this.password, application: app });
                this.loading = false;

                this.$di.appSwitcher.navigate(app, path);
            }
            catch(e){

                const errorCode = getGraphQLError(e);

                this.logger.error('Error logging in', errorCode, e);
                this.loading = false;

                if(errorCode === ApiError.NO_ACCESS_APPLICATION){
                    this.$toast.error('Je hebt geen toegang tot deze applicatie');
                }
                else if(errorCode === ApiError.AUTH_USER_LOCKED){
                    this.$toast.error('Vanwege het aantal mislukte inlogpogingen is het account vergrendeld voor 30 minuten');
                }
                else if(errorCode === ApiError.AUTH_USER_PASSWORD_EXPIRED){

                    this.$toast.warning('Je wachtwoord is verlopen');

                    this.$router.replace({
                        name: 'renew-password',
                        params: {
                            email: this.username
                        },
                        query: this.$route.query
                    });
                }
                else {
                    this.$toast.error('Onjuiste inloggegevens, probeer het opnieuw');
                }
            }
        }
    }

</script>
